module.exports = __webpack_public_path__ + "static/media/Snorlax_gaussian2.b26020ae.png";